/**
 * 挂号模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 获取医生排班列表
export const scheduleList = (params) => {
  return req.get('/order/registered/scheduling/list', params);
}

// 获取挂号列表
export const registerList = (params) => {
  return req.get('/order/registered/list', params);
}

// 获取已签到挂号列表
export const registerSignInList = (params) => {
  return req.get('/order/signIn/diagnoseList', params);
}

// 新增挂号
export const registerAdd = (params, uuid, code) => {
  if (uuid && code) return req.post(`/order/registered?uuid=${uuid}&code=${code}`, params);
  else return req.post(`/order/registered/createRegsiter`, params);
  // else return req.post(`/order/registered`, params);
}

// 挂号支付
export const registerPay = (params) => {
  return req.put('/order/registered', params);
}

// 未支付取消挂号
export const registerCancel = (registeredId) => {
  return req.put(`/order/registered/cancel/${registeredId}`);
}

// 已支付取消挂号
export const registerRefund = (params) => {
  return req.put('/order/registered/refund', params);
}

// 已支付取消挂号&微信退款
export const registerRefund1 = (orderId) => {
  return req.post(`/wechat/pay/registerRefund/${orderId}`);
}

// 挂号后签到
export const registerSign = (registeredId) => {
  return req.put(`/order/registered/sign/${registeredId}`);
}

// 签到叫号
export const signCall = (params) => {
  return req.post('/order/signIn/signCall', params);
}


// 获取小票数据
export const print = (registeredId) => {
  return req.get(`/order/registered/receipts/${registeredId}`);
}

// 获取挂号详细信息
export const registeredInfo = (registeredId) => {
  return req.get(`/order/registered/${registeredId}`);
}

// 获取扫码签到记录
export const scanRecord = (params) => {
  return req.get('/order/registered/getOrderSignRecord', params);
}

// 获取挂号列表各状态的数量
export const statusNum = (params) => {
  return req.get(`/order/info/selectStatusNumber`, params);
}



// 获取划价订单列表
export const orderList = (params) => {
  return req.get('/order/info/paymentList', params);
}

// 待划价列表的各类订单数量
export const pricingListNum = (params) => {
  return req.get('/order/info/paymentListNum', params);
}
//查询医生和患者的关联关系
export const getRelation = (params) => {
  return req.get('/order/registered/relation/get', params);
}
//保存医生和患者的关联关系
export const saveRelation = (params) => {
  return req.post('/order/registered/relation/save', params);
}



